<!-- version 2021/05/20 -->
<template>
  <label class="label">
    <input
      type="radio"
      class="radio"
      :name="name"
      :value="value"
      :checked="is_checked"
    >
    <div class="button" />
    <span class="ml10">{{ title }}</span>
  </label>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    checked: {
      type: Boolean,
      default: null,
    }
  },
  data() {
    return {
      is_checked: this.checked,
    };
  },
};
</script>

<style lang="sass" scoped>

.label
  display: flex
  cursor: pointer
  margin: 10px

.radio
  display: none

.button
  width: 26px
  height: 26px
  border: solid 2px #e5e5e5
  background: #f1f5f5
  border-radius: 50%
  -webkit-transition: 0.2s
  transition: 0.2s

.radio
  &:checked
    &~ .button
      border: solid 2px #28c3cd
      background: #fff

      &::after
        content: ""
        display: block
        left: 5px
        top: 5px
        height: 12px
        width: 12px
        border-radius: 50%
        background: #28c3cd
        position: relative

</style>
